import React, { Component, createRef } from 'react';
import $ from 'jquery';
import { Container, Row, Col, FormControl, Button, ListGroup, FormGroup } from 'react-bootstrap';

class URLManager extends Component {
    constructor(props) {
        super(props);
        this.urlDefaultErrorMessage = "Please enter a valid URL (starting with http:// or https://)"
        this.state = {
            inputValue: '',
            jobStartURLValid: true,
            urlErrorMessage: this.urlDefaultErrorMessage,
        };
        this.jobStartURLInputRef = createRef();
    }

    extractDomain(siteUrl) {
            $.post("/api/v1/extractions/" + this.props.extractionId + "/extract_domain", JSON.stringify({ "site_url": siteUrl}), (res, text, xhr) => {
                var urlValid = false;
                var urlErrorMessage = this.urlDefaultErrorMessage;
                if (res.domain) {
                    urlValid = true;
                } else {
                    urlErrorMessage = res.error
                }
                this.setState({
                    jobStartURLValid: urlValid,
                    urlErrorMessage: urlErrorMessage
                });
        }, "json");
    } 

    getStartUrlValidationState() {
        const { inputValue } = this.state;
        const extractedDomain = this.extractDomain(inputValue);
    }

    handleInputChange = (e) => {
        this.setState({ inputValue: e.target.value }, this.getStartUrlValidationState);
    };

    // Method to handle adding a new item
    handleAddItem = () => {
        const { inputValue, jobStartURLValid } = this.state;
        if (inputValue.trim() && jobStartURLValid) {
            // Create a new item with a null ID
            const newItem = {
                id: null,
                start_url: inputValue,
            };
            this.props.stateManagementService.updateJobDefinition({ ...this.props.jobDefinition, job_urls: [...this.props.jobDefinition.job_urls, newItem] }).then(() => {
                this.setState({
                    inputValue: '',    // Clear the input field after adding
                    jobStartURLValid: true,
                });
            }).catch(error => {
                console.error('Failed updating job definition:', error);
            });
        }
    };

    deleteStartUrl(index) {
        const { items } = this.props.jobDefinition.job_urls;
        const newItems = items.filter((_, i) => i !== index);
        const url_to_delete = items[index];
        var urls_to_delete = this.props.jobDefinition.urls_to_delete
        if (url_to_delete.id != null) {
            urls_to_delete.push(url_to_delete.id);
        }
        this.props.stateManagementService.updateJobDefinition({ ...this.props.jobDefinition, job_urls: newItems, urls_to_delete: urls_to_delete }).catch(error => {
            console.error('Failed updating job definition:', error);
        });
    }

    render() {
        const items = this.props.jobDefinition?.job_urls ?? [];
        const { inputValue, jobStartURLValid, urlErrorMessage } = this.state;

        return (
            <Container style={{ padding:0 }}>
                <Row>
                    <Col md={2} className={"my-2"}>
                        Start URL:
                    </Col>
                    <Col md={8}>
                        <FormGroup>
                            <FormControl
                                isInvalid={!jobStartURLValid}
                                type="text"
                                placeholder="Enter URL"
                                value={inputValue}
                                ref={this.jobStartURLInputRef}
                                onChange={this.handleInputChange}
                            />
                            <FormControl.Feedback type="invalid">
                                {urlErrorMessage}
                            </FormControl.Feedback>
                        </FormGroup>
                    </Col>
                    <Col md={2} className={"text-end"} >
                        <Button
                            onClick={this.handleAddItem}
                            variant="primary"
                            disabled={!jobStartURLValid || inputValue.trim() === ''}
                        >
                            Add
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col md={12} className={"my-3"}>
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <ListGroup>
                                {items.map((item, index) => (
                                    <ListGroup.Item key={item.id} className="d-flex justify-content-between align-items-center">
                                        {item.start_url}
                                        <Button
                                            variant="secondary"
                                            size="sm"
                                            onClick={() => this.deleteStartUrl(index)}
                                        >
                                            Delete
                                        </Button>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default URLManager;